import angular from 'angular'
import { configureStates, lazyLoad } from '../../core/router/router-helper.provider';

export const workOrderDetailCommonConfig = {
    url: "^/work-orders/{workOrderID:int}/detail",
    resolve: {
        workOrder: ($transition$, workOrderService) => {
            'ngInject';
            return workOrderService.retrieveWorkOrder($transition$.params().workOrderID)
                .then(workOrder => {
                    const pOrder = [];
                    workOrder.ProductOrders.forEach(po => {
                        [].concat(po.StatusHistory).forEach(st => {
                            pOrder.push({
                                Product: po.Product,
                                ProductLine: po.ProductLine,
                                ProductOrderID: po.ProductOrderID,
                                Quantity: po.Quantity,
                                StatusHistory: st
                            })
                        });
                    });
                    workOrder.ProductOrdersAndStatus = pOrder;
                    return workOrder;
                });
        },
        office: (workOrder, icdOfficeService) => {
            'ngInject';
            return icdOfficeService.retrieveIcdOffice(workOrder.IcdOfficeID)
        },
        corporation: (office, icdCorporationService) => {
            'ngInject';
            return icdCorporationService.retrieveIcdCorporation(office.IcdCorporationID)
        },
        employee: (workOrder, employeeService) => {
            'ngInject';
            return employeeService.retrieveEmployee(workOrder.Employment.EmployeeID)
        }
    }
};

const routes = [{
    state: "workOrder",
    config: {
        url: "/work-orders",
        abstract: true,
    }
}, {
    // Redirect from MVC route to semantic route.
    state: "leads.importWorkOrders",
    config: {
        url: "/importworkorders",
        redirectTo: "workOrder.importer"
    }
}, {
    state: "workOrder.importer",
    config: {
        url: "/importer",
        component: "apexWorkOrdersImporter",
        data: {
            pageHeader: "Import Work Orders",
            permissionKey: "navigation:importWorkOrders"
        },
        lazyLoad: lazyLoad(() => import("./importer/work-order-importer.module").then(mod => mod.WorkOrderImporterModule))
    }
}, {
    state: "workOrder.workOrderDetails",
    config: {
        ...workOrderDetailCommonConfig,
        component: "apexWorkOrderDetailContainer",
        url: "/{workOrderID:int}/details",
        resolve: {
            workOrder: workOrderDetailCommonConfig.resolve.workOrder,
            office: workOrderDetailCommonConfig.resolve.office,
            corporation: workOrderDetailCommonConfig.resolve.corporation,
            employee: workOrderDetailCommonConfig.resolve.employee
        }
    }
}];

export const WorkOrderRoutingModule = angular.module("apex.mainApp.workOrder.routing", [])
    .run(configureStates(routes))
    .name;
